var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.75,
    height: 29.75,
    viewBox: "0 0 29.75 29.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_6",
    "data-name": "\\uD569\\uCE58\\uAE30 6",
    d: "M-6196.482,12499.053l-10.607-10.606-10.606,10.606a2.5,2.5,0,0,1-3.535,0,2.5,2.5,0,0,1,0-3.536l10.606-10.606-10.606-10.606a2.5,2.5,0,0,1,0-3.535,2.494,2.494,0,0,1,3.535,0l10.606,10.606,10.607-10.606a2.494,2.494,0,0,1,3.535,0,2.5,2.5,0,0,1,0,3.535l-10.606,10.606,10.606,10.606a2.5,2.5,0,0,1,0,3.536,2.5,2.5,0,0,1-1.769.731A2.492,2.492,0,0,1-6196.482,12499.053Z",
    transform: "translate(6221.965 -12470.034)",
    fill: "#12233a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBtn);
export default __webpack_public_path__ + "static/media/closeBtn.46eda4c83814a2131f04ad05c0741351.svg";
export { ForwardRef as ReactComponent };